import React, { useEffect, useState } from 'react'
import Translation from '../../../global/Translation'

const DisplayEclosBrand = ({isBrandEclos, responsiveFontSize = false}) => {

        const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768)
    
        // Update the state on window resize
        useEffect(() => {
            const handleResize = () => {
                setIsDesktop(window.innerWidth >= 768)
            }
    
            window.addEventListener("resize", handleResize)
    
            return () => {
                window.removeEventListener("resize", handleResize)
            }
        }, [])

    const styles = {
        background: 'linear-gradient(90deg,rgba(155, 98, 42, 1) 1%, rgba(156, 128, 104, 1) 31%, rgba(112, 42, 19, 1) 100%)',
        color: '#FFFFFF',
        padding: '4px 8px',
        fontSize: isDesktop && responsiveFontSize ? '12px' : '8px',
        fontWeight: '500',
        zIndex: 1,
        lineHeight: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }

    return isBrandEclos ? (
        <div style={styles}>
            <Translation id="new_brand_eclos" defaultMessage="New Brand: ECLOS®" />
        </div>
    ) : null
}

export default DisplayEclosBrand
